import { useMediaDevice } from '@elem/compPage/Oasis/hooks';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Dialog from './Dialog';
import { useState } from 'react';

export default function ConsultationForm({ callback, desc }: any) {
    const { useRouter } = useGlobal();
    const { isPad, isH5 } = useMediaDevice();
    const { locale } = useRouter();
    // 弹窗
    const [open, setOpen] = useState(false);

    const clickHandle = () => {
        setOpen(true);
    };
    // 关闭
    const closeHandle = (e: any) => {
        e?.stopPropagation(); //阻止冒泡
        callback && callback('close');
    };
    const onCloseDialog = (e: any) => {
        e?.stopPropagation(); //阻止冒泡
        setOpen(false);
    };
    return (
        <div className={`${css.ConsultationForm} ConsultationForm`} onClick={clickHandle}>
            {!(isPad || isH5) && (
                <div className="ConsultationForm-pc">
                    <span className="close" onClick={(e) => closeHandle(e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path
                                d="M12.4548 2.69727C17.8939 2.69735 22.3035 7.10678 22.3035 12.5459C22.3034 17.9849 17.8939 22.3945 12.4548 22.3945C7.01572 22.3945 2.60628 17.985 2.6062 12.5459C2.6062 7.10673 7.01567 2.69727 12.4548 2.69727ZM15.9314 9.06836C15.6429 8.78027 15.1748 8.78007 14.8865 9.06836L12.4539 11.5L10.0222 9.06836C9.73373 8.78026 9.26563 8.78002 8.97729 9.06836C8.68896 9.3567 8.68919 9.8248 8.97729 10.1133L11.4089 12.5449L8.97729 14.9775C8.689 15.2659 8.68921 15.734 8.97729 16.0225C9.26574 16.3109 9.73377 16.3109 10.0222 16.0225L12.4539 13.5898L14.8865 16.0225C15.1749 16.3108 15.643 16.3109 15.9314 16.0225C16.2198 15.734 16.2198 15.266 15.9314 14.9775L13.4988 12.5449L15.9314 10.1133C16.2198 9.82484 16.2198 9.3568 15.9314 9.06836Z"
                                fill="#919191"
                            />
                        </svg>
                    </span>
                    <div className="title">購入前のご相談</div>
                    <div className="items">
                        <div className="item">
                            <p className="item-l">ご相談のカテゴリーをお選びください</p>
                            <p className="item-r">必須</p>
                        </div>
                        <div className="item">
                            <p className="item-l">最も興味のある商品をお選びください</p>
                            <p className="item-r">必須</p>
                        </div>
                        <div className="item">
                            <p className="item-l">この製品のご利用用途をお選びください</p>
                            <p className="item-r">必須</p>
                        </div>
                        <div className="item">
                            <p className="item-l">ご利用目的の詳細を選択してください </p>
                            <p className="item-r">必須</p>
                        </div>
                    </div>
                    <div className="btn">送信</div>
                </div>
            )}
            {(isPad || isH5) && <div className="ConsultationForm-h5">購入前のご相談</div>}
            {open && <Dialog open={open} onClose={(e) => onCloseDialog(e)} />}
        </div>
    );
}
